import { apiFetch, type RequestAuth } from './client';

/** Raw gondor version state, as returned per shard. */
export type AppVersionState =
  | 'NEW'
  | 'PUBLISHED'
  | 'BUILD_FAILED'
  | 'STARTING'
  | 'START_FAILED'
  | 'RUNNING'
  | 'UPGRADING_RUNTIME'
  | 'STOPPING'
  | 'STOP_FAILED'
  | 'STOPPED'
  | 'ABANDONED';

export interface VersionShardState {
  state: AppVersionState;
  updatedAt: string;
}

export interface AppVersionItem {
  version: string;
  /** shardId -> state on that shard. States can diverge across shards. */
  shards: Record<string, VersionShardState>;
  /** max(shards[*].updatedAt); the list is sorted by this descending server-side. */
  latestUpdatedAt: string;
}

/** rivendell `GET /dev-portal/apps/{appId}/versions`. */
export interface AppVersionsResponse {
  items: AppVersionItem[];
  degradedShards: string[];
}

export function getAppVersions(auth: RequestAuth, appId: string): Promise<AppVersionsResponse> {
  return apiFetch<AppVersionsResponse>(`/dev-portal/apps/${encodeURIComponent(appId)}/versions`, auth);
}
